module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-d7d1a29f.png";